import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { observer } from 'mobx-react';
import React, { useRef } from 'react';
import { PrerenderedCanvas } from '@jbrowse/core/ui';
function WiggleRendering(props) {
  var regions = props.regions,
    features = props.features,
    bpPerPx = props.bpPerPx,
    width = props.width,
    height = props.height,
    _props$onMouseLeave = props.onMouseLeave,
    _onMouseLeave = _props$onMouseLeave === void 0 ? function () {} : _props$onMouseLeave,
    _props$onMouseMove = props.onMouseMove,
    _onMouseMove = _props$onMouseMove === void 0 ? function () {} : _props$onMouseMove,
    _props$onFeatureClick = props.onFeatureClick,
    onFeatureClick = _props$onFeatureClick === void 0 ? function () {} : _props$onFeatureClick;
  var _regions = _slicedToArray(regions, 1),
    region = _regions[0];
  var ref = useRef(null);
  function getFeatureUnderMouse(eventClientX) {
    // calculates feature under mouse
    var offset = 0;
    if (ref.current) {
      offset = ref.current.getBoundingClientRect().left;
    }
    var offsetX = eventClientX - offset;
    var px = region.reversed ? width - offsetX : offsetX;
    var clientBp = region.start + bpPerPx * px;
    var featureUnderMouse;
    var _iterator = _createForOfIteratorHelper(features.values()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var feature = _step.value;
        // bpPerPx added to the end to accommodate "reduced features" (one feature per px)
        if (clientBp <= feature.get('end') + bpPerPx && clientBp >= feature.get('start')) {
          featureUnderMouse = feature;
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return featureUnderMouse;
  }
  return React.createElement("div", {
    ref: ref,
    "data-testid": "wiggle-rendering-test",
    onMouseMove: function onMouseMove(event) {
      var _a;
      return _onMouseMove(event, (_a = getFeatureUnderMouse(event.clientX)) === null || _a === void 0 ? void 0 : _a.id());
    },
    onClick: function onClick(event) {
      var _a;
      return onFeatureClick(event, (_a = getFeatureUnderMouse(event.clientX)) === null || _a === void 0 ? void 0 : _a.id());
    },
    onMouseLeave: function onMouseLeave(event) {
      return _onMouseLeave(event);
    },
    style: {
      overflow: 'visible',
      position: 'relative',
      height: height
    }
  }, React.createElement(PrerenderedCanvas, _objectSpread({}, props)));
}
export default observer(WiggleRendering);